import script from "./BenefitsVerificationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BenefitsVerificationCard.vue?vue&type=script&setup=true&lang=ts"

import "./BenefitsVerificationCard.vue?vue&type=style&index=0&id=306d407c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-306d407c"]])

export default __exports__